<template>
	<div class="h-screen flex w-full bg-img">
		<div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
			<vx-card>
				<div
					slot="no-body"
					class="full-page-bg-color"
				>
					<div class="vx-row">
						<div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
							<img
								src="@/assets/images/pages/reset-password.png"
								alt="login"
								class="mx-auto"
							>
						</div>
						<div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
							<vs-alert
								active="true"
								color="danger"
								v-if="errorMessages"
							>
								<span
									v-for="(error, index) in errorMessages"
									:key="index"
								>
									{{ error[0] }}<br>
								</span>
							</vs-alert>
							<div class="p-8">
								<div class="vx-card__title mb-8">
									<h4 class="mb-4">Új jelszó beállítása</h4>
								</div>
								<vs-input
									type="email"
									label-placeholder="E-mail"
									v-model="passwordReset.email"
									class="w-full mb-6"
									v-on:keyup.enter="resetPassword"
								/>
								<vs-input
									type="password"
									label-placeholder="Jelszó"
									v-model="passwordReset.password"
									class="w-full mb-6"
									v-on:keyup.enter="resetPassword"
								/>
								<vs-input
									type="password"
									label-placeholder="Jelszó ismét"
									v-model="passwordReset.passwordConfirmation"
									class="w-full mb-8"
									v-on:keyup.enter="resetPassword"
								/>

								<div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
									<vs-button
										type="border"
										to="/login"
										class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
									>Vissza a bejelentkezéshez</vs-button>
									<vs-button
										class="w-full sm:w-auto"
										@click="resetPassword()"
									>Új jelszó mentése</vs-button>
								</div>

							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			errorMessages: null,
			passwordReset: {
				email: '',
				password: '',
				passwordConfirmation: ''
			}
		}
	},
	methods: {
		resetPassword() {

			// Loading
			// this.$vs.loading()

			this.passwordReset.activationToken = this.$route.params.token

			this.$http.post("/api/users/create-password", this.passwordReset)
				.then((response) => {
					console.log(response.data.message);
					this.$router.push({ name: 'login', params: { message: response.data.message } })
				}).catch((error) => {
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Hiba',
						text: error.response.data.message,
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
				})




		},
	},
	created() {

	}
}
</script>
